// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1___ecfd561bf8f90f14f35{/*!*/}.FeedbackModal-cls2___cf6aa911b3f458ac589{padding-top:16px;width:100%}@media(min-width: 768px){.FeedbackModal-cls2___cf6aa911b3f458ac589{width:80%}}.FeedbackModal-cls2___cf6aa911b3f458ac589 button{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___ecfd561bf8f90f14f35",
	"cls2": "FeedbackModal-cls2___cf6aa911b3f458ac589 FeedbackModal-cls1___ecfd561bf8f90f14f35"
};
export default ___CSS_LOADER_EXPORT___;
